import React, { useEffect } from 'react';
import { Box } from '@mui/material';

function Hal() {
  useEffect(() => {
    // Open the ElevenLabs widget in a new tab
    const newTab = window.open('', '_blank');
    if (newTab) {
      newTab.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Hal</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
              background-color: #f5f5f5;
            }
          </style>
        </head>
        <body>
          <elevenlabs-convai agent-id="agent_1901kcvdb61ce2xv18nf4tq5kc8e"></elevenlabs-convai>
          <script src="https://unpkg.com/@elevenlabs/convai-widget-embed" async type="text/javascript"></script>
          <script>
            // Wait for the ElevenLabs widget to load and auto-click the call button
            function waitForCallButton() {
              const maxAttempts = 50; // Try for up to 5 seconds (50 * 100ms)
              let attempts = 0;
              
              const interval = setInterval(() => {
                attempts++;
                
                // Find the elevenlabs-convai element
                const widget = document.querySelector('elevenlabs-convai');
                
                if (widget && widget.shadowRoot) {
                  // Look for the "Start a call" button inside the Shadow DOM
                  const callButton = widget.shadowRoot.querySelector('button[aria-label="Start a call"]');
                  
                  if (callButton) {
                    console.log('Found call button in Shadow DOM, clicking it...');
                    callButton.click();
                    clearInterval(interval);
                    return;
                  }
                }
                
                if (attempts >= maxAttempts) {
                  console.log('Call button not found after maximum attempts');
                  clearInterval(interval);
                }
              }, 100); // Check every 100ms
            }
            
            // Start checking after the page loads
            window.addEventListener('load', () => {
              // Give the widget a moment to initialize
              setTimeout(waitForCallButton, 500);
            });
          </script>
        </body>
        </html>
      `);
      newTab.document.close();
    }
    
    // Navigate back or close the current view since we're opening in a new tab
    window.history.back();
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <p>Opening Hal in a new tab...</p>
    </Box>
  );
}

export default Hal;
